import React, { Dispatch, SetStateAction, useState } from 'react';
import GoogleMapReact, { Coords } from 'google-map-react';
import isEmpty from 'lodash.isempty';
import {  Record } from 'react-admin';

const  Philadelphia_CENTER = {
  lat: 39.952583,
  lng: -75.165222
} ;
import AutoComplete from './autocomplete';
interface AddressMapProps {
  showAutoComplete?: boolean;
  setAutoComplete?: Dispatch<SetStateAction<google.maps.places.PlaceResult | {}>>
  records: {
    oldRecord: Record,
    newRecord?:  Record | {}
  }
}

const AddressMap: React.FC<AddressMapProps> = props =>  { 
  const {showAutoComplete, setAutoComplete, records} = props;

  const [mapApiLoaded, setMapApiLoaded] = useState(false);
  const [mapInstance, setMapInstance] = useState<null | google.maps.Map>(null);
  const [mapApi, setMapApi] = useState<null | any>(null);
  const [initialAddress] = useState([records?.oldRecord]);
  const [center, setCenter] = useState<{ lat: number | undefined; lng: number | undefined;}>(Philadelphia_CENTER);

  const addAutoCompletePlace = (place: google.maps.places.PlaceResult[] | null) => {
    if(place) setAutoComplete!(place[0]);
    if(!place) {
      setAutoComplete!({});
      return setCenter({
        lat: records?.oldRecord?.latitude,
        lng: records?.oldRecord?.longitude,
      });
    }
    const position = {
      lat: place[0].geometry?.location?.lat(),
      lng: place[0].geometry?.location?.lng(),
    }
    const marker = mapApi && new mapApi.Marker({
      position,
      mapInstance,
    });
    marker.setMap(mapInstance);
    
    const infoWindow = new mapApi.InfoWindow({
      content: getInfoWindowString(place[0]),
    });
    infoWindow.open(mapInstance, marker);
    marker.addListener('click', () => {
      infoWindow.open(mapInstance, marker);
    });
    setCenter(position)
  };

  const getInfoWindowString = (place: any) => `
    <div>
      <div style="font-size: 16px;">
        ${place?.full_address || place?.formatted_address}
      </div>
    </div>`;

  const handleApiLoaded = (map: any, maps: any, places: any) => {
    setMapApiLoaded(true);
    setMapInstance(map);
    setMapApi(maps);
    const markers: google.maps.Marker[] = [];
    const infowindows: any[] = [];
      
    places.forEach((place: { latitude: any; longitude: any; }) => {
      markers.push(new maps.Marker({
        position: {
          lat: place?.latitude,
          lng: place?.longitude,
        },
        map,
      }));
      
      infowindows.push(new maps.InfoWindow({
        content: getInfoWindowString(place),
      }));
    });
      
    markers.forEach((marker, i) => {
      infowindows[i].open(map, marker);
      marker.addListener('click', () => {
        infowindows[i].open(map, marker);
      });
    });
    setCenter({
      lat: places[0]?.latitude,
      lng: places[0]?.longitude,
    })
  };

  return (
    <>
      {!isEmpty(initialAddress) && 
      <div style={{width: '100%', height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {showAutoComplete && mapApiLoaded && <AutoComplete addAutoCompletePlace={addAutoCompletePlace} maps={mapApi} />}
        <div style={{width: '100%', height: '100%', border: '1px #cccccc solid', borderRadius: '5px',  display: 'flex',
          flexDirection: 'column'}}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: process.env.REACT_APP_MAP_KEY as string,
              libraries: ['places', 'geometry'],
            }}
            defaultZoom={15}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps, initialAddress)}
            center={center as Coords}
          />
        </div>    
        
      </div>
      }
    </>
  );
}

export default AddressMap;